// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__OTAxZ","bpk-no-touch-support":"FAQ_bpk-no-touch-support__YWVlY"};